import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { Material } from 'src/app/interfaces/material';
import { MaterialsProviderService } from 'src/app/providers/materials/materials.provider.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialsService extends ApiService<Material, MaterialsProviderService> {
  private materialsProviderService = inject(MaterialsProviderService);
  protected override get provider(): MaterialsProviderService {
    return this.materialsProviderService;
  }
}
